import React from 'react';
import { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { formChangedAction } from 'actions';
import Moment from 'moment';
import EnlargableTextbox from 'components/common/EnlargableTextbox';
import {
  paymentDetailAction
} from 'actions/ClientPayment/clientPaymentAction';
import { getClientCaseMasterListAPI } from 'actions/CaseNextDate/caseNextDateAction';

export const PaymentDetails = () => {
  const dispatch = useDispatch();
  const [formHasError, setFormError] = useState(false);
  const [clientCaseMasterList, setClientCaseMasterList] = useState([]);
  const resetPaymentData = () => {
    dispatch(
      paymentDetailAction({
        encryptedClientPaymentId: '',
        caseNo: '',
        paymentType: '',
        paymentNo:"",
        chequeDate: "",
         paymentDate: Moment().format('YYYY-MM-DD'),
        amount: '',
      })
    );
    setClientCaseMasterList([]);
  };

  const clientPaymentDetailReducer = useSelector(
    state => state.rootReducer.clientPaymentReducer
  );

  var paymentDetail = clientPaymentDetailReducer.paymentData;
  const formChangedReducer = useSelector(
    state => state.rootReducer.formChangedReducer
  );
  if (
    !clientPaymentDetailReducer.paymentData ||
    clientPaymentDetailReducer.paymentData.length <= 0
  ) {
    resetPaymentData();
  }

  const clientPaymentErrorReducer = useSelector((state) => state.rootReducer.clientPaymentErrorReducer)
  const paymentError = clientPaymentErrorReducer.paymentDetailsError;

  var formChangedData = formChangedReducer.formChanged;
  useEffect(() => {
    if (localStorage.getItem("ClientCode")) {
      getClientCaseMasterList(localStorage.getItem("ClientCode"))
    }

  }, [localStorage.getItem("ClientCode")]);

  useEffect(() => {
    
    if(paymentDetail.paymentType == "Cash"){
      $('#txtPaymentNo').attr('disabled', true);
      $('#dtChequeDate').attr('disabled', true);
    }
    else if(paymentDetail.paymentType == "Cheque"){
      $('#dtChequeDate').attr('disabled', false);
    }else if(paymentDetail.paymentType == "" || paymentDetail.paymentType == "Cash"){
      $('#dtChequeDate').attr('disabled', true);
      $('#dtChequeDate').val("");
    }

  }, [paymentDetail.paymentType || localStorage.getItem("ClientCode")]);

  // useEffect(() => {
  //   if(paymentDetail.paymentType == "Cash"){
  //     $('#txtPaymentNo').attr('disabled', true);
  //   }
  // }, [localStorage.getItem("ClientCode")]);

  let token = localStorage.getItem('Token') || sessionStorage.getItem('Token');
  const headers = {
    Authorization: `Bearer ${JSON.parse(token).value}`
  };
  
  const getClientCaseMasterList = async clientCode => {
    const data = {
      EncryptedAdvocateCode: localStorage.getItem('EncryptedAdvocateCode'),
      ClientCode: clientCode ? clientCode : localStorage.getItem('ClientCode')
    };
    await dispatch(
      getClientCaseMasterListAPI(
        data,
        res => {
          let caseMasterData = [];
          if (res.data && res.data.data.caseMasterList.length > 0) {
            res.data.data.caseMasterList.forEach(data => {
              caseMasterData.push({
                key: `${data.caseNo} --- ${data.caseTitle}`,
                value: data.caseNo
              });
            });
            setClientCaseMasterList(caseMasterData);
          } else {
            setClientCaseMasterList([]);
          }
        },
        err => {
          setClientCaseMasterList([]);
        },
        headers
      )
    );
  };

  const handleFieldChange = e => {
    const todayDate = new Date().toISOString().split('T')[0]; 
    if (e.target.name == 'caseNo' ) {
      dispatch(
        paymentDetailAction({
          ...paymentDetail,
           paymentNo: '',
          chequeDate: "",
          amount:"",
          paymentType: '',
          [e.target.name]: e.target.value
        })
      );
      $('#dtChequeDate').val("");
    } 
    if (e.target.name == 'paymentType' && e.target.value == "") {
      dispatch(
        paymentDetailAction({
          ...paymentDetail,
           paymentNo: '',
          chequeDate: "",
          [e.target.name]: ""
        })
      );
      $('#dtChequeDate').val("");
    } 
    if (e.target.value == 'Cash') {
      $('#txtPaymentNo').attr('disabled', true);
      $('#dtChequeDate').attr('disabled', true);
      dispatch(
        paymentDetailAction({
          ...paymentDetail,
          paymentNo: '',
          chequeDate: "",
          [e.target.name]: e.target.value
        })
      );
    } else if(e.target.value == 'Cheque'){
      $('#txtPaymentNo').attr('disabled', false);
      $('#dtChequeDate').attr('disabled', false);
      dispatch(
        paymentDetailAction({
          ...paymentDetail,
          paymentNo: '',
          [e.target.name]: e.target.value
        })
      );

    }
   else {
      dispatch(
        paymentDetailAction({
          ...paymentDetail,
          [e.target.name]: e.target.value,
          paymentDate: e.target.name === 'paymentDate' && e.target.value 
          ? e.target.value  
          : (paymentDetail.paymentDate || todayDate) 
        })
      );
    }
        if (paymentDetail.encryptedClientPaymentId) {
          dispatch(
            formChangedAction({
              ...formChangedData,
              paymentDetailUpdate: true
            })
          );
        } else {
          dispatch(
            formChangedAction({
              ...formChangedData,
              paymentDetailAdd: true
            })
          );
        }
  };

  return (
    <>
      <Form
        noValidate
        validated={formHasError}
        className="details-form client-payment-card"
        id="AddPaymentDetailsForm"
      >
        <Row>
          <Col className="me-3 ms-3">
            <Row className="mb-3">
              <Form.Label>
                Case No.<span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                id="txtCaseNo"
                name="caseNo"
                onChange={(e)=>handleFieldChange(e)}
                value={paymentDetail.caseNo}
              >
                <option value="">Select Case No</option>
                {clientCaseMasterList.map((option, index) => (
                  <option key={index} value={option.value}>
                    {option.key}
                  </option>
                ))}
              </Form.Select>
              {Object.keys(paymentError.caseNoErr).map(
                key => {
                  return (
                    <span className="error-message">
                      {paymentError.caseNoErr[key]}
                    </span>
                  );
                }
              )}
            </Row>
            <Row className="mb-3">
              <Form.Label>
                Payment Date
              </Form.Label>
              <Form.Control
                type="date"
                id="dtPaymentDate"
                name="paymentDate"
                value={
                  paymentDetail.paymentDate
                    ? Moment(paymentDetail.paymentDate).format('YYYY-MM-DD')
                    : Moment().format('YYYY-MM-DD')
                }
                onChange={(e)=>handleFieldChange(e)}
                required
              />
                {/* {Object.keys(paymentError.paymentDateErr).map(key => {
                return (
                  <span className="error-message">{paymentError.paymentDateErr[key]}</span>
                );
              })} */}
            </Row>
          </Col>
          <Col className="me-3 ms-3">
            <Row className="mb-3">
              <Form.Label>
                Payment Type<span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                id="txtPaymentType"
                name="paymentType"
                value={paymentDetail.paymentType}
                onChange={(e)=>handleFieldChange(e)}
                required
              >
                <option value="">Select Payment Type</option>
                <option value="Cheque">Cheque</option>
                <option value="Cash">Cash</option>
              </Form.Select>
              {Object.keys(paymentError.paymentTypeErr).map(key => {
                return (
                  <span className="error-message">{paymentError.paymentTypeErr[key]}</span>
                );
              })}
            </Row>
            {paymentDetail.paymentType == "Cheque" &&
            <Row className="mb-3">
              <Form.Label>
                Cheque Date
              </Form.Label>
              <Form.Control
                type="date"
                id="dtChequeDate"
                name="chequeDate"
                disabled
                value={
                  paymentDetail.chequeDate
                    ? Moment(paymentDetail.chequeDate).format('YYYY-MM-DD')
                    : ""
                }
                onChange={(e)=>handleFieldChange(e)}
                required
              />
              {Object.keys(paymentError.chequeDateErr).map(key => {
                return (
                  <span className="error-message">{paymentError.chequeDateErr[key]}</span>
                );
              })}
            </Row>
}
          </Col>  
          <Col className="me-3 ms-3">
          {paymentDetail.paymentType == "Cheque" &&
            <Row className="mb-3">
              <Form.Label>Payment No.</Form.Label>
              <EnlargableTextbox
                id="txtPaymentNo"
                name="paymentNo"
                type="text"
                maxLength={50}
                disabled = {paymentDetail.paymentType == "Cheque" ? false : true}
                value={paymentDetail.paymentNo}
                onChange={(e)=>handleFieldChange(e)}
                placeholder="Enter payment no"
              />
              {Object.keys(paymentError.paymentNoErr).map(key => {
                return (
                  <span className="error-message">{paymentError.paymentNoErr[key]}</span>
                );
              })}
            </Row>
          }
            <Row className="mb-3">
              <Form.Label>
                Amount<span className="text-danger">*</span>
              </Form.Label>
              <EnlargableTextbox
                id="txtAmount"
                name="amount"
                maxLength={18}
                min={0}
                onChange={(e)=>handleFieldChange(e)}
                placeholder="Enter amount"
                required={true}
                value={paymentDetail.amount}
                onKeyPress={e => {
                  const key = String.fromCharCode(e.charCode);
                  const currentValue = e.target.value;
                  if (key === '.' && currentValue.includes('.')) {
                    e.preventDefault();
                  }
                  const regex = /^[0-9\.]+$/;
                  if (!regex.test(key)) {
                    e.preventDefault();
                  }
                }}
              />
              {Object.keys(paymentError.amountErr).map(key => {
                return <span className="error-message">{paymentError.amountErr[key]}</span>;
              })}
            </Row>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default PaymentDetails;
